import React from 'react';
import './article.css';

const Article = () => (
  
  <div className="banner">
      <div className="baner-content">
        <img alt="logo" src="https://raw.githubusercontent.com/denisdanailov/SoftUni-Software-Engineering/main/log-softuni.png" />
        </div>
  </div>
);

export default Article;
